import React from 'react';
import { DESCRIPTION_MAX_LENGTH } from '../../../config/constants';
import VerticalField from '../VerticalField';
import FieldLabel from '../FieldLabel';
import FieldError from '../FieldError';
import TextAreaField from '../TextAreaField';

// Complete text area field prepared for descriptions with length error

interface IProps {
  label: string;
  value: string;
  targetErrorElement: string;
  placeholder?: string;
  error?: string;
  onChange?: (value: string) => void;
  hasError?: boolean;
  disabled?: boolean;
  noMargin?: boolean;
}

export default ({
  label,
  value,
  targetErrorElement,
  placeholder,
  error,
  onChange,
  hasError,
  disabled,
  noMargin,
}: IProps) => {
  const maxLengthExceeded =
    !error && value.trim().length > DESCRIPTION_MAX_LENGTH;
  const isInvalid = maxLengthExceeded || hasError || Boolean(error);

  return (
    <VerticalField noMargin={noMargin}>
      <FieldLabel>{label}</FieldLabel>
      <TextAreaField
        value={value}
        onChange={onChange}
        placeholder={placeholder || 'Add description'}
        minRows={2}
        maxRows={5}
        hasError={isInvalid}
        disabled={disabled}
      />
      {maxLengthExceeded && (
        <FieldError
          type="length"
          targetElement={targetErrorElement}
          isDescription
          maxLength={DESCRIPTION_MAX_LENGTH}
        />
      )}
      {error && <FieldError type="custom" customError={error} />}
    </VerticalField>
  );
};
